export default __webpack_public_path__ + "static/media/Lowest.0dac7042.png";